<template>
    <info-container :header-text="spielerName" :width="950"
                     :action="action" :valid-actions="[action]"
                     header-icon="mdi-information-outline" @close="close">
        <v-tabs grow v-model="tab" :show-arrows="$vuetify.breakpoint.xsOnly" >
            <v-tab>Daten</v-tab>
            <v-tab>Ausweise</v-tab>
            <v-tab v-if="user.permissions.pass">Kugeln</v-tab>
            <v-tab>Vereinshistorie</v-tab>
            <v-tab>Änderungen</v-tab>
        </v-tabs>
        <v-tabs-items v-model="tab">
            <v-tab-item>
                <spieler-data v-if="spieler" :spieler="spieler"></spieler-data>
            </v-tab-item>
            <v-tab-item>
                <div class="pa-3 grey lighten-3">
                    <spieler-rollen v-if="spieler" :spieler="spieler"></spieler-rollen>
                </div>
            </v-tab-item>
            <v-tab-item v-if="user.permissions.pass">
                <div class="pa-3 grey lighten-3">
                    <kugel-home :owner="spieler" owner-type="spieler"/>
                </div>
            </v-tab-item>
            <v-tab-item>
                <spieler-history v-if="spieler" :spieler="spieler"></spieler-history>
            </v-tab-item>
            <v-tab-item>
                <spieler-log v-if="spieler" :spieler="spieler"></spieler-log>
            </v-tab-item>
        </v-tabs-items>
    </info-container>
</template>

<script>
    import InfoContainer from "../../../components/form/infoContainer";
    import SpielerData from "./spielerData";
    import SpielerLog from "./spielerLog";
    import SpielerHistory from "./spielerHistory";
    import SpielerRollen from "@/views/spielerTabelle/spielerInfo/spielerRollen";
    import KugelHome from "@/views/kugeln/kugelHome";

    export default {
        components: {
            KugelHome,
            SpielerRollen,
            SpielerHistory,
            SpielerLog,
            SpielerData,
            InfoContainer},
        name: "spieler-info",
        props: {
            spieler: {default: null},
            action: { default: 'spielerInfo'}
        },
        data: () => ({
            tab: null,
        }),
        computed: {
            user(){ return this.$store.state.user },
            spielerName(){return this.spieler ?
                this.spieler.vorname + ' ' + this.spieler.nachname + ' / ' + this.spieler.passNr : ''}
        },
        methods: {
            close(){
                this.tab = null;
            }
        },
    }
</script>

<style scoped>

</style>